import { restClient } from 'api/rest-client';
import {
  GiftCardOrdersDto,
  GiftCardUpdateDto,
  GiftCardOrdersStatusDto,
  GiftCardProductsDto,
} from 'api/types/giftCard/giftCard';
import { TOTAL_COUNT_HEADER } from 'shared/consts/headers';
import { UrlParams } from 'shared/types/giftCards';
import { getGiftCardsParams } from 'shared/utils/giftCards';

export const getOrders = (urlParams: UrlParams) => {
  return restClient
    .get<GiftCardOrdersDto>('gift/giftCards', { params: getGiftCardsParams(urlParams) })
    .then((response) => {
      return { orders: response.data.data, total: response.headers[TOTAL_COUNT_HEADER] as number };
    });
};

export const getExportedOrders = (urlParams: UrlParams) => {
  return restClient
    .get<GiftCardOrdersDto>('gift/giftCards/export', { params: getGiftCardsParams(urlParams) })
    .then((response) => ({ orders: response.data.data, total: response.headers[TOTAL_COUNT_HEADER] as number }));
};

export const updateOrder = (id: string, status: string) => {
  return restClient
    .patch<GiftCardUpdateDto>(`gift/giftCards/${id}`, { orderStatus: status })
    .then((response) => response.data);
};

export const getOrderStatus = () => {
  return restClient.get<GiftCardOrdersStatusDto>('gift/giftCards/orderstatus').then((response) => response.data);
};

export const getProducts = () => {
  return restClient.get<GiftCardProductsDto>('gift/giftCards/products').then((response) => response.data);
};
